import React, { useState, useEffect } from 'react';
import { Modal } from "react-bootstrap";
import WithRoutify from '../../../hoc/WithRoutify';
import NewPatientDetails from '../NewUIEmrPage/NewPatientDetails';
import NewCompanyDetails from '../../EmployeeVisitContainer/NewEmployeeVisitDetailView/newCompanyDetails';
import EmrVisitsService from '../../../services/EmrVisitsService';
import FileManagerService from '../../../services/FileManagerService';
import { formatPhoneNumber } from '../../../utils/commonUtils';
import FormInputs from '../../../components/UI/FormInputs';
import Alert from '../../../components/UI/ConfirmBox/Alert';
import dayjs from 'dayjs';
import Icons from '../../../components/UI/Icons';
import PERMISSIONS from '../../../utils/AclPermissions';
import Acl from '../../../hoc/Acl';
import { acl_check } from '../../../utils/aclUtils';
import withReduxState from '../../../hoc/wReduxState';


const WorkRestrictionsModal = (props) => {
 const { isOpen, onClose, visit_id, employeeId, employeeDetails, fetchEmployeeDetails, visitDetails, Loader, workStatusFormData, Toast, profile } = props;
 
 // Check if user has edit permission
 const hasEditAccess = profile?.permissions ? acl_check(profile.permissions, PERMISSIONS.WORK_STATUS.EDIT) : false;
//  console.log('employeeDetails', employeeDetails);
console.log('visitDetails company', visitDetails?.company);
 const [workStatusSummary, setWorkStatusSummary] = useState(null);
 const [loading, setLoading] = useState(false);
 const [showSendAlert, setShowSendAlert] = useState(false);
 const [existingWorkStatusForm, setExistingWorkStatusForm] = useState(null);


 useEffect(() => {
   if (isOpen && visit_id) {
     // Check if work status form already exists first, then fetch summary
     const loadData = async () => {
       const existingForm = await checkExistingWorkStatusForm();
       await fetchWorkStatusSummary(existingForm);
     };
     loadData();
   } else if (!isOpen) {
     // Reset state when modal closes
     setWorkStatusSummary(null);
     setExistingWorkStatusForm(null);
     setShowSendAlert(false);
   }
 }, [isOpen, visit_id]);

 // Check if work status form exists
 const checkExistingWorkStatusForm = async () => {
   if (!visit_id) return null;
   try {
     const existingForm = await EmrVisitsService.getWorkStatusFormById(visit_id);
     setExistingWorkStatusForm(existingForm);
     return existingForm;
   } catch (error) {
     console.error('Error checking existing work status form:', error);
     setExistingWorkStatusForm(null);
     return null;
   }
 };

 // Update workStatusSummary when workStatusFormData is provided (only once when modal opens)
 useEffect(() => {
   if (workStatusFormData && isOpen && !workStatusSummary) {
     // Initialize with form data if summary hasn't been loaded yet
     setWorkStatusSummary({
       signature: workStatusFormData.employee_signature || '',
       date: workStatusFormData.date ? dayjs(workStatusFormData.date).format('MM/DD/YYYY') : '',
       orders_instructions: workStatusFormData.instructions || '',
       email_sent: workStatusFormData.email_sent || false,
       sms_sent: workStatusFormData.sms_sent || false,
       status: workStatusFormData.status || '',
     });
   }
 }, [workStatusFormData, isOpen]);

 // Merge existing form data into workStatusSummary when it becomes available or changes
 useEffect(() => {
   if (existingWorkStatusForm && workStatusSummary) {
     setWorkStatusSummary((prev) => ({
       ...prev,
       signature: existingWorkStatusForm.employee_signature || prev?.signature || '',
       date: existingWorkStatusForm.date ? dayjs(existingWorkStatusForm.date).format('MM/DD/YYYY') : (prev?.date || ''),
       orders_instructions: existingWorkStatusForm.instructions || prev?.orders_instructions || '',
       email_sent: existingWorkStatusForm.email_sent !== undefined ? existingWorkStatusForm.email_sent : (prev?.email_sent || false),
       sms_sent: existingWorkStatusForm.sms_sent !== undefined ? existingWorkStatusForm.sms_sent : (prev?.sms_sent || false),
       status: existingWorkStatusForm.status || prev?.status || '',
     }));
   }
 }, [existingWorkStatusForm]);


 const fetchWorkStatusSummary = async (existingFormData = null) => {
   if (!visit_id) return;
  
   try {
     setLoading(true);
     if (Loader) Loader(true);
    
     const data = await EmrVisitsService.getWorkStatusSummary(visit_id);
    
     if (data && !data.error) {
       // Merge workStatusFormData if provided
       let mergedData = workStatusFormData ? {
         ...data,
         signature: workStatusFormData.employee_signature || data.signature,
         date: workStatusFormData.date ? dayjs(workStatusFormData.date).format('MM/DD/YYYY') : data.date,
         orders_instructions: workStatusFormData.instructions || data.orders_instructions,
       } : data;
       
       // Also merge existing form data if available (from checkExistingWorkStatusForm)
       if (existingFormData) {
         mergedData = {
           ...mergedData,
           signature: existingFormData.employee_signature || mergedData.signature || '',
           date: existingFormData.date ? dayjs(existingFormData.date).format('MM/DD/YYYY') : (mergedData.date || ''),
           orders_instructions: existingFormData.instructions || mergedData.orders_instructions || '',
           email_sent: existingFormData.email_sent !== undefined ? existingFormData.email_sent : (mergedData.email_sent || false),
           sms_sent: existingFormData.sms_sent !== undefined ? existingFormData.sms_sent : (mergedData.sms_sent || false),
           status: existingFormData.status || mergedData.status || '',
         };
       }
       
       setWorkStatusSummary(mergedData);
       console.log('Work Status Summary Data:', mergedData);
     } else {
       // If summary fetch fails but we have form data, use form data
       if (workStatusFormData) {
         setWorkStatusSummary({
           signature: workStatusFormData.employee_signature || '',
           date: workStatusFormData.date ? dayjs(workStatusFormData.date).format('MM/DD/YYYY') : '',
           orders_instructions: workStatusFormData.instructions || '',
         });
       } else if (existingFormData) {
         // Use existing form data if available
         setWorkStatusSummary({
           signature: existingFormData.employee_signature || '',
           date: existingFormData.date ? dayjs(existingFormData.date).format('MM/DD/YYYY') : '',
           orders_instructions: existingFormData.instructions || '',
           email_sent: existingFormData.email_sent || false,
           sms_sent: existingFormData.sms_sent || false,
           status: existingFormData.status || '',
         });
       } else {
         console.error('Error fetching work status summary:', data?.error || 'Unknown error');
         if (props.Toast) {
           props.Toast.error(data?.message || 'Failed to fetch work status summary');
         }
       }
     }
   } catch (error) {
     console.error('Error fetching work status summary:', error);
     // If summary fetch fails but we have form data, use form data
     if (workStatusFormData) {
       setWorkStatusSummary({
         signature: workStatusFormData.employee_signature || '',
         date: workStatusFormData.date ? dayjs(workStatusFormData.date).format('MM/DD/YYYY') : '',
         orders_instructions: workStatusFormData.instructions || '',
       });
     } else if (existingFormData) {
       // Use existing form data if available
       setWorkStatusSummary({
         signature: existingFormData.employee_signature || '',
         date: existingFormData.date ? dayjs(existingFormData.date).format('MM/DD/YYYY') : '',
         orders_instructions: existingFormData.instructions || '',
         email_sent: existingFormData.email_sent || false,
         sms_sent: existingFormData.sms_sent || false,
         status: existingFormData.status || '',
       });
     } else {
       if (props.Toast) {
         props.Toast.error('Failed to fetch work status summary');
       }
     }
   } finally {
     setLoading(false);
     if (Loader) Loader(false);
   }
 };
 const convertDateToYYYYMMDD = (dateString) => {
   if (!dateString) return '';
   // Convert from MM/DD/YYYY to YYYY-MM-DD
   const date = dayjs(dateString, 'MM/DD/YYYY');
   return date.isValid() ? date.format('YYYY-MM-DD') : '';
 };

 const handleSave = async () => {
   if (!visit_id || !employeeId) {
     if (Toast) {
       Toast.error('Missing required information');
     }
     return;
   }

   try {
     if (Loader) Loader(true);
     
     // Check if this is a new save (work status form doesn't exist)
     const isNewSave = !existingWorkStatusForm;
     
     // Convert date from MM/DD/YYYY to YYYY-MM-DD
     const formattedDate = convertDateToYYYYMMDD(workStatusSummary?.date);

     const payload = {
       employee_id: employeeId,
       employee_signature: workStatusSummary?.signature || '',
       date: formattedDate,
       instructions: workStatusSummary?.orders_instructions || '',
       email_sent: workStatusSummary?.email_sent || false,
       sms_sent: workStatusSummary?.sms_sent || false,
       status: workStatusSummary?.status || '',
     };

     const response = await EmrVisitsService.saveWorkStatusForm(visit_id, payload);
     
     if (response && (response.code === 200 || response.code === 201)) {
       if (Toast) {
         Toast.success('Work status form saved successfully');
       }
       
       // Refresh the existing form status after saving
       await checkExistingWorkStatusForm();
       
       // If it was a new save, show alert asking to send email/SMS
       if (isNewSave) {
         setShowSendAlert(true);
       } else {
         // If it was an update, just close the modal
         if (onClose) {
           onClose();
         }
       }
     } else {
       if (Toast) {
         Toast.error(response?.message || 'Failed to save work status form');
       }
     }
   } catch (error) {
     console.error('Error saving work status form:', error);
     if (Toast) {
       Toast.error('Failed to save work status form');
     }
   } finally {
     if (Loader) Loader(false);
   }
 };

 // Handler for sending email and SMS
 const handleSendReport = async () => {
   try {
     if (Loader) Loader(true);
     const employeeEmail = employeeDetails?.email;
     const employeePhone = employeeDetails?.phone;
     const employeeName = employeeDetails 
           ? `${employeeDetails.first_name || ''} ${employeeDetails.last_name || ''}`.trim()
           : 'employee';

     let emailSent = false;
     let smsSent = false;

     // Send email if available
     if (employeeEmail) {
           try {
                 const emailResponse = await EmrVisitsService.sendWorkStatusFormEmail(visit_id, employeeEmail);
                 if (emailResponse && (emailResponse.code === 200 || emailResponse.code === 201)) {
                       emailSent = true;
                 }
           } catch (err) {
                 console.error("Error sending email:", err);
           }
     }

     // Send SMS if available
     if (employeePhone) {
           try {
                 const smsResponse = await EmrVisitsService.sendWorkStatusFormSMS(visit_id, employeePhone);
                 if (smsResponse && (smsResponse.code === 200 || smsResponse.code === 201)) {
                       smsSent = true;
                 }
           } catch (err) {
                 console.error("Error sending SMS:", err);
           }
     }

     // Show success message
     if (emailSent && smsSent) {
           if (Toast) {
                 Toast.success(`Work status report sent successfully to ${employeeName} via email and SMS`);
           }
     } else if (emailSent) {
           if (Toast) {
                 Toast.success(`Work status report sent successfully to ${employeeName} via email`);
           }
     } else if (smsSent) {
           if (Toast) {
                 Toast.success(`Work status report sent successfully to ${employeeName} via SMS`);
           }
     } else {
           if (Toast) {
                 Toast.error("Failed to send work status report. Please check employee contact information.");
           }
     }

     // Update email_sent and sms_sent flags by calling save API if at least one was sent successfully
     if ((emailSent || smsSent) && visit_id && employeeId) {
           try {
                 const savePayload = {
                       employee_id: employeeId,
                       email_sent: emailSent || workStatusSummary?.email_sent || false,
                       sms_sent: smsSent || workStatusSummary?.sms_sent || false,
                 };
                 
                 await EmrVisitsService.saveWorkStatusForm(visit_id, savePayload);
                 
                 // Update local state to reflect the new flags
                 setWorkStatusSummary((prev) => ({
                       ...prev,
                       email_sent: savePayload.email_sent,
                       sms_sent: savePayload.sms_sent,
                 }));
           } catch (err) {
                 console.error("Error saving email/sms sent flags:", err);
                 // Don't show error to user as the email/SMS was already sent successfully
           }
     }

     // Close alert and modal
     setShowSendAlert(false);
     if (onClose) {
           onClose();
     }
   } catch (err) {
         console.error("Error sending report:", err);
         if (Toast) {
               Toast.error("Failed to send work status report");
         }
   } finally {
         if (Loader) Loader(false);
   }
 };

 // Handler for not sending report
 const handleDontSend = () => {
   setShowSendAlert(false);
   // Close modal
   if (onClose) {
         onClose();
   }
 };

 // Handler for printing work status form
 const handlePrint = async () => {
   try {
     if (Loader) Loader(true);
     
     const response = await EmrVisitsService.printWorkStatusForm(visit_id);
     
     // Handle different response structures
     const base64Data = typeof response === 'string' ? response : (response?.data || response);
     
     if (base64Data && typeof base64Data === 'string' && base64Data.length > 0) {
       const pdfData = {
         file_content: base64Data,
         original_name: `snap work status report`,
         mime_type: 'application/pdf'
       };
       FileManagerService.printPdf(pdfData);
     } else {
       console.error("Invalid PDF data received:", base64Data);
       if (Toast) {
         Toast.error("Failed to generate work status form PDF");
       }
     }
   } catch (error) {
     console.error("Error printing work status form:", error);
     if (Toast) {
       Toast.error("Failed to print work status form");
     }
   } finally {
     if (Loader) Loader(false);
   }
 };

 // Handler for sending email
 const handleSendEmail = async () => {
   try {
     if (Loader) Loader(true);
     
     const employeeEmail = employeeDetails?.email;
     
     if (!employeeEmail) {
       if (Toast) {
         Toast.error("Employee email not found. Cannot send email.");
       }
       return;
     }

     const response = await EmrVisitsService.sendWorkStatusFormEmail(visit_id, employeeEmail);
     
     if (response && (response.code === 200 || response.code === 201)) {
       if (Toast) {
         Toast.success("Work status report sent successfully to " + employeeEmail);
       }
       
       // Update email_sent flag by calling save API
       const savePayload = {
         employee_id: employeeId,
         email_sent: true,
        //  sms_sent: workStatusSummary?.sms_sent || false,
       };
       
       await EmrVisitsService.saveWorkStatusForm(visit_id, savePayload);
     } else {
       if (Toast) {
         Toast.error(response?.data?.error || response?.message || "Failed to send work status report email");
       }
     }
   } catch (error) {
     console.error("Error sending work status form email:", error);
     if (Toast) {
       Toast.error("Failed to send work status report email");
     }
   } finally {
     if (Loader) Loader(false);
   }
 };

 // Handler for sending SMS
 const handleSendSMS = async () => {
   try {
     if (Loader) Loader(true);
     
     const employeePhone = employeeDetails?.phone;
     
     if (!employeePhone) {
       if (Toast) {
         Toast.error("Employee phone number not found. Cannot send SMS.");
       }
       return;
     }

     const response = await EmrVisitsService.sendWorkStatusFormSMS(visit_id, employeePhone);
     
     if (response && (response.code === 200 || response.code === 201)) {
       if (Toast) {
         Toast.success("Work status report SMS sent successfully to " + employeePhone);
       }
       
       // Update sms_sent flag by calling save API
       const savePayload = {
         employee_id: employeeId,
        //  email_sent: workStatusSummary?.email_sent || false,
         sms_sent: true,
       };
       
       await EmrVisitsService.saveWorkStatusForm(visit_id, savePayload);
     } else {
       if (Toast) {
         Toast.error(response?.data?.error || response?.message || "Failed to send work status report SMS");
       }
     }
   } catch (error) {
     console.error("Error sending work status form SMS:", error);
     if (Toast) {
       Toast.error("Failed to send work status report SMS");
     }
   } finally {
     if (Loader) Loader(false);
   }
 };

 const formatWorkRestrictions = (restrictions) => {
  if (!restrictions) return null;


  const restrictionLabels = {
    relatedness: 'Relatedness',
    work_status: 'Work Status',
    weight_bearing: 'Weight Bearing',
    lifting_carrying: 'Lifting/Carrying',
    sitting_standing: 'Sitting/Standing',
    standing_duration: 'Standing Duration',
    walking_distance: 'Walking Distance',
    pushing_pulling: 'Pushing/Pulling',
    work_restriction_breaks: 'Breaks',
    max_shift_length: 'Max Shift Length',
    equipment_use: 'Equipment Use',
    overhead_reaching: 'Overhead Reaching',
    repetitive_grasping: 'Repetitive Grasping',
    climbing_stairs_ladders: 'Climbing Stairs/Ladders',
    squatting_kneeling: 'Squatting/Kneeling',
    work_restriction_bending_back: 'Bending Back',
    work_restriction_spine: 'Spine Restrictions',
    dme_use: 'DME Use',
    environmental_exposures: 'Environmental Exposures',
  };


  const restrictionItems = [];
 
  Object.keys(restrictionLabels).forEach((key) => {
    const value = restrictions[key];
    // Explicitly check for null, undefined, empty string, and whitespace-only strings
    // Skip if value is null, undefined, empty string, or only whitespace
    if (value === null || value === undefined || value === '' || (typeof value === 'string' && value.trim() === '')) {
      return; // Skip this field entirely
    }
   
    const label = restrictionLabels[key];
    // Split comma-separated values and format each one
    // Filter out null, undefined, empty strings, and string "null" or "undefined"
    const values = String(value)
      .split(',')
      .map(v => v.trim())
      .filter(v => v && v !== 'null' && v !== 'undefined' && v !== '');
   
    // Only add if there are valid values after filtering
    if (values.length > 0) {
      values.forEach(v => {
        restrictionItems.push(`${label}: ${v}`);
      });
    }
  });


  return restrictionItems.length > 0 ? restrictionItems : null;
};



 return (
   <>
     <Modal
       show={isOpen}
       onHide={onClose}
       dialogClassName="modal-dialog modal-dialog hResponsive FullScreen modal-lg modal-lg"
       contentClassName="h-100"
       keyboard={false}
       backdrop="static"
     >
       <div className="sh_modalBox" style={{ backgroundColor: '#F7F9FF' }}>
         <Modal.Header closeButton className='bg-white'>
           <Modal.Title>
             <h6 className="text-lg mb-0 font-weight-bold">Work Status</h6>
           </Modal.Title>
         </Modal.Header>
         <div className="modal-header border-0">
           <div className="w-100 d-flex gap-2 justify-content-end">
             <Acl acl={PERMISSIONS.WORK_STATUS.LIST}>
               <a 
                 className="new-btn-icon" 
                 onClick={existingWorkStatusForm ? handlePrint : undefined} 
                 title={existingWorkStatusForm ? "Print" : "Print is disabled"} 
                 style={{ 
                   cursor: existingWorkStatusForm ? 'pointer' : 'not-allowed',
                   opacity: existingWorkStatusForm ? 1 : 0.5,
                   pointerEvents: existingWorkStatusForm ? 'auto' : 'none'
                 }}
               >
                 <Icons type="Print" size={16} />
               </a>
             </Acl>
             <Acl acl={PERMISSIONS.WORK_STATUS.EDIT}>
               <a 
                 className="new-btn-icon" 
                 onClick={existingWorkStatusForm ? handleSendEmail : undefined} 
                 title={existingWorkStatusForm ? "Send Email" : "Send Email is disabled"} 
                 style={{ 
                   cursor: existingWorkStatusForm ? 'pointer' : 'not-allowed',
                   opacity: existingWorkStatusForm ? 1 : 0.5,
                   pointerEvents: existingWorkStatusForm ? 'auto' : 'none'
                 }}
               >
                 <Icons type="Email" size={16} />
               </a>
             </Acl>
             <Acl acl={PERMISSIONS.WORK_STATUS.EDIT}>
               <a 
                 className="new-btn-icon" 
                 onClick={existingWorkStatusForm ? handleSendSMS : undefined} 
                 title={existingWorkStatusForm ? "Send SMS" : "Send SMS is disabled"} 
                 style={{ 
                   cursor: existingWorkStatusForm ? 'pointer' : 'not-allowed',
                   opacity: existingWorkStatusForm ? 1 : 0.5,
                   pointerEvents: existingWorkStatusForm ? 'auto' : 'none'
                 }}
               >
                 <Icons type="Phone" size={16} />
               </a>
             </Acl>
           </div>
         </div>
         <Modal.Body>
           <div className="row">
             <div className="col-md-3 col-12">
               <div style={{ position: 'sticky', top: '0px', zIndex: 1 }}>
                 {visit_id && employeeId && (
                   <NewPatientDetails
                     visit_id={visit_id}
                     employeeId={employeeId}
                     employeeDetails={employeeDetails || {}}
                     fetchEmployeeDetails={fetchEmployeeDetails}
                   />
                 )}
                 <NewCompanyDetails
                   companyDetails={visitDetails?.company}
                 />
               </div>
             </div>
             <div className="col-md-9 col-12">
               <div className="sh_cardBox bg-white mb-3">
                 <div className="sh_cardHeader mx-3">
                   <div className="d-flex justify-content-between w-100">
                     <div>
                       <div className="image-container">
                         {workStatusSummary?.organization_logo ? (
                           <img
                             src={`data:image/png;base64,${workStatusSummary.organization_logo}`}
                             alt="Organization Logo"
                           />
                         ) : (
                           <img src="public/assets/img/logo.png" alt="Snap Logo" />
                         )}
                       </div>
                     </div>
                     <div>
                       <p className="text-dark mb-0">Date: {workStatusSummary?.visit_date || '-'}</p>
                       <p className="text-dark mb-0 font-weight-bold">{workStatusSummary?.clinic?.name || '-'}</p>
                       <p className="text-dark mb-0">
                         {workStatusSummary?.clinic?.address
                           ? workStatusSummary.clinic.address
                           : workStatusSummary?.clinic?.city && workStatusSummary?.clinic?.state && workStatusSummary?.clinic?.zip_code
                             ? `${workStatusSummary.clinic.city}, ${workStatusSummary.clinic.state} ${workStatusSummary.clinic.zip_code}`
                             : workStatusSummary?.clinic?.city && workStatusSummary?.clinic?.state
                               ? `${workStatusSummary.clinic.city}, ${workStatusSummary.clinic.state}`
                               : '-'}
                       </p>
                       <p className="text-dark mb-0">
                         {workStatusSummary?.clinic?.phone
                           ? formatPhoneNumber(workStatusSummary.clinic.phone)
                           : '-'}
                         {workStatusSummary?.clinic?.phone && workStatusSummary?.clinic?.fax ? ', ' : ''}
                         {workStatusSummary?.clinic?.fax
                           ? `Fax: ${formatPhoneNumber(workStatusSummary.clinic.fax)}`
                           : workStatusSummary?.clinic?.phone ? '' : '-'}
                       </p>
                     </div>
                   </div>
                   <h5 className="text-center font-weight-bold mb-0">WORK STATUS SUMMARY</h5>
                 </div>
                 <div className="sh_cardHeader sh_patietoverviewcard mx-3">
                   <div className="py-2">
                     <h6 className="fw-semibold fs-6 text-dark px-2">Patient Overview</h6>
                     <div className="row g-3">
                       <div className="col-md col-6">
                         <span>
                           <p className="mb-1 small text-muted fs-14">Patient Name</p>
                           <h6 className="font-weight-bold text-dark mb-2">
                             {workStatusSummary?.incident?.patient_name
                               ? workStatusSummary.incident.patient_name
                               : workStatusSummary?.patient
                                 ? `${workStatusSummary.patient.first_name || ''} ${workStatusSummary.patient.last_name || ''}`.trim() || '-'
                                 : '-'}
                           </h6>
                         </span>
                         <span>
                           <p className="mb-1 small text-muted fs-14">DOS</p>
                           <p className="fw-medium text-dark mb-0">{workStatusSummary?.visit_date || '-'}</p>
                         </span>
                       </div>
                       <div className="col-md col-6 border-left border-2" style={{ borderColor: 'rgb(148, 160, 184)' }}>
                         <span>
                           <p className="mb-1 small text-muted fs-14">Injury Location</p>
                           <p className="fw-medium text-dark mb-2">
                             {workStatusSummary?.incident?.injury_location
                               ? workStatusSummary.incident.injury_location.replace(/_/g, ' ').replace(/,/g, ', ')
                               : '-'}
                           </p>
                         </span>
                         <span>
                           <p className="mb-1 small text-muted fs-14">Body Zone</p>
                           <p className="fw-medium text-dark mb-0">{workStatusSummary?.incident?.body_zone || '-'}</p>
                         </span>
                       </div>
                       <div className="col-md col-6 border-left border-2" style={{ borderColor: 'rgb(148, 160, 184)' }}>
                         <span>
                           <p className="mb-1 small text-muted fs-14">Nature of Incident</p>
                           <p className="fw-medium text-dark mb-2">{workStatusSummary?.incident?.nature_of_incident || '-'}</p>
                         </span>
                         <span>
                           <p className="mb-1 small text-muted fs-14">Injury Date</p>
                           <p className="fw-medium text-dark mb-0">{workStatusSummary?.incident?.injury_date || '-'}</p>
                         </span>
                       </div>
                       <div className="col-md col-6 border-left border-2" style={{ borderColor: 'rgb(148, 160, 184)' }}>
                         <span>
                           <p className="mb-1 small text-muted fs-14">Company Name</p>
                           <p className="fw-medium text-dark mb-2">{workStatusSummary?.incident?.company_name || '-'}</p>
                         </span>
                         <span>
                           <p className="mb-1 small text-muted fs-14">Company Phone</p>
                           <p className="fw-medium text-dark mb-0">
                             {visitDetails?.company?.phone
                               ? formatPhoneNumber(visitDetails.company.phone)
                               : '-'}
                           </p>
                         </span>
                       </div>
                       <div className="col-md col-6 border-left border-2" style={{ borderColor: 'rgb(148, 160, 184)' }}>
                         <span>
                           <p className="mb-1 small text-muted fs-14">Insurance Name</p>
                            <p className="fw-medium mb-2 text-dark">
                            {workStatusSummary?.incident?.insurance_name || '-'}
                          </p>
                         </span>
                         <span>
                           <p className="mb-1 small text-muted fs-14">Insurance Phone</p>
                            <p className="fw-medium text-dark mb-0">
                              {workStatusSummary?.incident?.insurance_phone
                                ? formatPhoneNumber(workStatusSummary.incident.insurance_phone)
                                : '-'}
                            </p>
                         </span>
                       </div>
                     </div>
                   </div>
                 </div>
                 <div className="card-body sh_cardBody">
                   <div className="card border-0">
                     <div className="card-header border-0 p-2">
                       <h6 className="font-weight-bold m-0 text-md">Patient Details</h6>
                     </div>
                     <div className="card-body border rounded mt-2 p-2">
                       <div className="row">
                         {/* Employee Section */}
                         <div className="col-md-6 px-0">
                           <div className="row">
                             <div className="mb-2 col-12">
                               <label className="f-400 text-sm text-truncate mb-1">Employee</label>
                               <h6 className="font-weight-bold text-sm text-truncate mb-0">{employeeDetails?.first_name || '-'} {employeeDetails?.last_name || '-'}</h6>    
                               <h6 className="font-weight-bold text-sm text-truncate mb-0">
                                   {[
                                    employeeDetails?.street,
                                    employeeDetails?.city,
                                    employeeDetails?.state,
                                    employeeDetails?.zip_code
                                  ].filter(Boolean).join(', ') || '-'}
                               </h6>
                             </div>
                             <div className="col-6 mb-3">
                               <label className="f-400 text-sm text-truncate mb-1">Identification</label>
                               <h6 className="font-weight-bold text-sm text-truncate mb-0">{employeeDetails?.identification_number || '-'}</h6>
                             </div>
                             <div className="col-6 mb-3">
                               <label className="f-400 text-sm text-truncate mb-1">DOB</label>
                               <h6 className="font-weight-bold text-sm text-truncate mb-0">{employeeDetails?.dob || '-'}</h6>
                             </div>
                             <div className="col-6 mb-3">
                               <label className="f-400 text-sm text-truncate mb-1">Email</label>
                               <h6 className="font-weight-bold text-sm text-truncate mb-0">{employeeDetails?.email || '-'}</h6>
                             </div>
                             <div className="col-6 mb-3">
                               <label className="f-400 text-sm text-truncate mb-1">Phone</label>
                               <h6 className="font-weight-bold text-sm text-truncate mb-0">{formatPhoneNumber(employeeDetails?.phone) || '-'}</h6>
                             </div>
                           </div>
                         </div>
                         {/* Employer Section */}
                         <div className="col-md-6 px-0">
                           <div className="row">
                             <div className="mb-2 col-12">
                               <label className="f-400 text-sm text-truncate mb-1">Employer</label>
                               <h6 className="font-weight-bold text-sm text-truncate mb-0">{visitDetails?.company?.name || '-'}</h6>
                               <h6 className="font-weight-bold text-sm text-truncate mb-0">
                                 {visitDetails?.company?.address || '-'}
                               </h6>
                             </div>
                             <div className="col-6 mb-3">
                               <label className="f-400 text-sm text-truncate mb-1">Contact</label>
                               <h6 className="font-weight-bold text-sm text-truncate mb-0"> {visitDetails?.company?.address || '-'}</h6>
                             </div>
                             <div className="col-6 mb-3">
                               <label className="f-400 text-sm text-truncate mb-1">Email</label>
                               <h6 className="font-weight-bold text-sm text-truncate mb-0">{visitDetails?.company?.general_email || '-'}</h6>
                             </div>
                             <div className="col-6 mb-3">
                               <label className="f-400 text-sm text-truncate mb-1">Phone</label>
                               <h6 className="font-weight-bold text-sm text-truncate mb-0">{formatPhoneNumber(visitDetails?.company?.phone) || '-'}</h6>
                             </div>
                             <div className="col-6 mb-3">
                               <label className="f-400 text-sm text-truncate mb-1">Fax</label>
                               <h6 className="font-weight-bold text-sm text-truncate mb-0">{formatPhoneNumber(visitDetails?.company?.fax) || '-'}</h6>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                   </div>
                   <div className="card border-0">
                     <div className="card-header border-0 p-2">
                       <h6 className="font-weight-bold m-0 text-md">Presenting Problem</h6>
                     </div>
                     <div className="card-body border rounded mt-2 p-0">
                       <table className="sh_tablenew table mb-0">
                         <thead>
                           <tr>
                             <th>Date Of Injury</th>
                             <th>Case Number</th>
                             <th>Claim Number</th>
                           </tr>
                         </thead>
                         <tbody>
                           <tr>
                             <td className="forTable_textEllipsis">{workStatusSummary?.incident?.injury_date || '-'}</td>
                             <td className="forTable_textEllipsis">{workStatusSummary?.incident?.case_number || '-'}</td>
                             <td className="forTable_textEllipsis">{workStatusSummary?.incident?.claim_number || '-'}</td>
                           </tr>
                           <tr>
                             <td className="forTable_textEllipsis bg-white" colSpan="3">
                               {workStatusSummary?.incident?.patient_incident_description || '-'}
                             </td>
                           </tr>
                         </tbody>
                       </table>
                     </div>
                   </div>
                  {/* HPI Section  */}
                   <div className="card border-0">
                       <div className="card-header border-0 p-2">
                          <h6 className="font-weight-bold m-0 text-md">HPI</h6>
                       </div>
                       <div className="card-body p-2 bg-white">
                            {workStatusSummary?.hpi ? (
                                 <div className="text-dark" style={{ whiteSpace: 'pre-wrap' }} 
                                   dangerouslySetInnerHTML={{ __html: workStatusSummary.hpi }} 
                                 />
                                   ) : (
                                  <span className="text-dark">No HPI data available</span>
                            )}
                       </div>
                    </div>
                    {/* End HPI Section */}
                   <div className="card border-0">
                     <div className="card-header border-0 p-2">
                       <h6 className="font-weight-bold m-0 text-md">Diagnosis</h6>
                     </div>
                     <div className="card-body border rounded mt-2 p-0">
                       <table className="sh_tablenew table mb-0">
                         <thead>
                           <tr>
                             <th>ICD</th>
                             <th></th>
                             <th></th>
                           </tr>
                         </thead>
                         <tbody>
                           {workStatusSummary?.diagnosis && workStatusSummary.diagnosis.length > 0 ? (
                             workStatusSummary.diagnosis.map((diagnosis, index) => {
                               // Parse description field: "CODE - Description"
                               let code = diagnosis.code || '-';
                               let description = diagnosis.description || '-';
                              
                               // If description contains " - ", split it
                               if (description && description.includes(' - ')) {
                                 const parts = description.split(' - ');
                                 code = parts[0] || code;
                                 description = parts.slice(1).join(' - ') || description;
                               }
                              
                               return (
                                 <tr key={index}>
                                   <td className="forTable_textEllipsis">{diagnosis.type || '-'}</td>
                                   <td className="forTable_textEllipsis">{code}</td>
                                   <td className="forTable_textEllipsis">{description}</td>
                                 </tr>
                               );
                             })
                           ) : (
                             <tr>
                               <td className="forTable_textEllipsis" colSpan="3">No diagnosis data available</td>
                             </tr>
                           )}
                         </tbody>
                       </table>
                     </div>
                   </div>
                   <div className="card border-0">
                     <div className="card-header border-0 p-2">
                       <h6 className="font-weight-bold m-0 text-md">Current Work Restrictions</h6>
                     </div>
                     <div className="card-body border rounded mt-2 p-0">
                       <table className="sh_tablenew table mb-0">
                         <thead>
                           <tr>
                             <th>Restrictions</th>
                             <th>Starting</th>
                             <th>Stop</th>
                           </tr>
                         </thead>
                         <tbody>
                           {workStatusSummary?.work_restrictions ? (
                             (() => {
                               const restrictions = formatWorkRestrictions(workStatusSummary.work_restrictions);
                               const startDate = workStatusSummary.work_restrictions.restrictions_start_date &&
                                                 workStatusSummary.work_restrictions.restrictions_start_date !== null
                                                 ? workStatusSummary.work_restrictions.restrictions_start_date : '-';
                               const endDate = (workStatusSummary.work_restrictions.restrictions_end_date_or_continued &&
                                               workStatusSummary.work_restrictions.restrictions_end_date_or_continued !== null)
                                               ? workStatusSummary.work_restrictions.restrictions_end_date_or_continued
                                               : (workStatusSummary.work_restrictions.restrictions_continued_date &&
                                                  workStatusSummary.work_restrictions.restrictions_continued_date !== null)
                                                 ? workStatusSummary.work_restrictions.restrictions_continued_date
                                                 : '-';
                              
                               return restrictions && restrictions.length > 0 ? (
                                 <tr>
                                   <td className="forTable_textEllipsis">
                                     <ul className="dashlist mb-0">
                                       {restrictions.map((item, index) => (
                                         <li key={index}>{item}</li>
                                       ))}
                                     </ul>
                                   </td>
                                   <td className="forTable_textEllipsis">{startDate}</td>
                                   <td className="forTable_textEllipsis">{endDate}</td>
                                 </tr>
                               ) : (
                                 <tr>
                                   <td className="forTable_textEllipsis" colSpan="3">No work restrictions available</td>
                                 </tr>
                               );
                             })()
                           ) : (
                             <tr>
                               <td className="forTable_textEllipsis" colSpan="3">No work restrictions available</td>
                             </tr>
                           )}
                         </tbody>
                       </table>
                     </div>
                   </div>
                   <div className="card border-0">
                     <div className="card-header border-0 p-2">
                       <h6 className="font-weight-bold m-0 text-md">Follow up Appointment </h6>
                     </div>
                     <div className="card-body border rounded mt-2 p-0">
                       <table className="sh_tablenew table mb-0">
                         <thead>
                           <tr>
                             <th>Follow up</th>
                             <th>Date</th>
                             <th>Time</th>
                           </tr>
                         </thead>
                         <tbody>
                           {workStatusSummary?.follow_ups && workStatusSummary.follow_ups.length > 0 ? (
                             workStatusSummary.follow_ups.map((followUp, index) => (
                               <tr key={followUp.visit_id || index}>
                                 <td className="forTable_textEllipsis">{followUp.visit_category || '-'}</td>
                                 <td className="forTable_textEllipsis">{followUp.visit_date || '-'}</td>
                                 <td className="forTable_textEllipsis">{followUp.visit_time || '-'}</td>
                               </tr>
                             ))
                           ) : (
                             <tr>
                               <td className="forTable_textEllipsis" colSpan="3">No follow-up appointments available</td>
                             </tr>
                           )}
                         </tbody>
                       </table>
                     </div>
                   </div>
                   <div className="card border-0">
                     <div className="card-header border-0 p-2">
                       <h6 className="font-weight-bold m-0 text-md">Orders & Instructions</h6>
                     </div>
                     <div className="card-body border rounded mt-2 p-2">
                       {/* <FormInputs
                         type="Editor"
                         value={workStatusSummary?.orders_instructions || ''}
                         changeHandler={(value) => setWorkStatusSummary({ ...workStatusSummary, orders_instructions: value })}
                         modules={{
                           toolbar: [
                             ['bold', 'italic', 'underline'],
                             [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                             ['clean'],
                           ],
                         }}
                         formats={['bold', 'italic', 'underline', 'list']}
                         height="150px"
                       /> */}
                       <FormInputs
                         type="TextArea"
                          value={workStatusSummary?.orders_instructions || ''}
                          changeHandler={(value) => {
                            setWorkStatusSummary(prev => ({
                              ...prev,
                              orders_instructions: value
                            }));
                          }}
                          className="form-control"
                          rows={10}
                          placeholder="Orders & Instructions"
                          disabled={false}
                          readOnly={!hasEditAccess}
                       />
                     </div>
                   </div>
                   <div className="card border-0 shadow-none h-auto mb-3">
                     <div className="card-header sh_basecardHeader">
                       <h6 className="m-0 text-md font-weight-bold">Patient Signature & Date</h6>
                     </div>
                     <div className="card-body p-2 sh_basecardBody">
                       <div className="row">
                         <div className="col-md-4 mb-3">
                           <div className="form-group mb-0">
                           <FormInputs 
                              type="NewSignature"
                              name="signature"
                              value={workStatusSummary?.signature || ''}
                              changeHandler={(value) => {
                                setWorkStatusSummary(prev => ({
                                  ...prev,
                                  signature: value
                                }));
                              }}
                              required={true}
                              label="Signature"
                              className="form-control"
                              placeholder="Signature"
                              style={{ width: '100%', height: '70px', border: '1px solid #ddd', borderRadius: '4px' }}
                              disabled={false}
                              readOnly={!hasEditAccess}
                             />
                             {/* {validation[field.id] && (
                               <div className="text-danger small mt-1">
                                 {validation[field.id]}
                               </div>
                             )} */}

                           </div>
                         </div>
                         <div className="col-md-4 mb-3">
                           <div className="form-group mb-0">
                             <label className="form-label mb-1">Date</label>
                             <FormInputs
                               type="Date"
                               name="date"
                               value={workStatusSummary?.date || ''}
                               changeHandler={(value) => {
                                 setWorkStatusSummary(prev => ({
                                   ...prev,
                                   date: value
                                 }));
                               }}
                               required={true}
                               label="Date"
                               className="form-control"
                               placeholder="Date"
                               style={{ width: '100%', height: '40px', border: '1px solid #ddd', borderRadius: '4px' }}
                               disabled={false}
                               readOnly={!hasEditAccess}
                             />

                           </div>
                         </div>
                       </div>
                     </div>
                   </div>
                 </div>
               </div>
             </div>
           </div>
         </Modal.Body>
         <Modal.Footer className="d-flex justify-content-center bg-white">
           <div className="d-flex gap-2 justify-content-end align-items-center w-100">
             <div className="d-flex gap-2">
               <Acl acl={PERMISSIONS.WORK_STATUS.LIST}>
                 <a 
                   className="new-btn-icon" 
                   onClick={existingWorkStatusForm ? handlePrint : undefined} 
                   title={existingWorkStatusForm ? "Print" : "Print is disabled"} 
                   style={{ 
                     cursor: existingWorkStatusForm ? 'pointer' : 'not-allowed',
                     opacity: existingWorkStatusForm ? 1 : 0.5,
                     pointerEvents: existingWorkStatusForm ? 'auto' : 'none'
                   }}
                 >
                   <Icons type="Print" size={16} />
                 </a>
               </Acl>
               <Acl acl={PERMISSIONS.WORK_STATUS.EDIT}>
                 <a 
                   className="new-btn-icon" 
                   onClick={existingWorkStatusForm ? handleSendEmail : undefined} 
                   title={existingWorkStatusForm ? "Send Email" : "Send Email is disabled"} 
                   style={{ 
                     cursor: existingWorkStatusForm ? 'pointer' : 'not-allowed',
                     opacity: existingWorkStatusForm ? 1 : 0.5,
                     pointerEvents: existingWorkStatusForm ? 'auto' : 'none'
                   }}
                 >
                   <Icons type="Email" size={16} />
                 </a>
               </Acl>
               <Acl acl={PERMISSIONS.WORK_STATUS.EDIT}>
                 <a 
                   className="new-btn-icon" 
                   onClick={existingWorkStatusForm ? handleSendSMS : undefined} 
                   title={existingWorkStatusForm ? "Send SMS" : "Send SMS is disabled"} 
                   style={{ 
                     cursor: existingWorkStatusForm ? 'pointer' : 'not-allowed',
                     opacity: existingWorkStatusForm ? 1 : 0.5,
                     pointerEvents: existingWorkStatusForm ? 'auto' : 'none'
                   }}
                 >
                   <Icons type="Phone" size={19} />
                 </a>
               </Acl>
             </div>
             <div>
               <button type="button" className="btn sh_btnlight text-sm" onClick={onClose}>Cancel</button>
               <Acl acl={PERMISSIONS.WORK_STATUS.EDIT}>
                 <button type="button" className="btn btn-primary" onClick={handleSave}>Save </button>
               </Acl>
             </div>
           </div>
        </Modal.Footer>
      </div>
    </Modal>
    {showSendAlert && (
      <Alert
        contentTitle={`Send Work Status Report to ${employeeDetails ? `${employeeDetails.first_name || ''} ${employeeDetails.last_name || ''}`.trim() : 'Employee'}?`}
        content={`Do you want to send this work status report to ${employeeDetails ? `${employeeDetails.first_name || ''} ${employeeDetails.last_name || ''}`.trim() : 'the employee'} via SMS and email?`}
        yesButtonName="Yes, Send"
        noButtonName="No, Don't Send"
        type="warning"
        custonTitle="Send Work Status Report"
        onDelete={handleSendReport}
        onClose={handleDontSend}
        confirmButtonClassName="btn btn-primary"
        cancelButtonClassName="btn btn-secondary"
      />
    )}
  </>
);
};


export default withReduxState(WithRoutify(WorkRestrictionsModal));

